import { render, staticRenderFns } from "./TargetSKU.vue?vue&type=template&id=3135b1ae&scoped=true&"
import script from "./TargetSKU.vue?vue&type=script&lang=js&"
export * from "./TargetSKU.vue?vue&type=script&lang=js&"
import style0 from "./TargetSKU.vue?vue&type=style&index=0&id=3135b1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3135b1ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3135b1ae')) {
      api.createRecord('3135b1ae', component.options)
    } else {
      api.reload('3135b1ae', component.options)
    }
    module.hot.accept("./TargetSKU.vue?vue&type=template&id=3135b1ae&scoped=true&", function () {
      api.rerender('3135b1ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Weekly/components/TargetSKU.vue"
export default component.exports